import { trigger, transition, style, animate, state } from "@angular/animations";
import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewEncapsulation,
	OnDestroy,
	HostListener,
	ViewChild,
	ElementRef,
	AfterViewInit,
	ChangeDetectorRef
} from "@angular/core";
import { IdService } from "../shared/services/id.service";
import { TabTrap } from "../shared/services/tabTrap.service";
import { ITransitionEvent } from "../transition/transition.interface";

@Component({
	selector: "rbc-modal",
	templateUrl: "./modal.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger("opacity", [
			transition(":enter", [
				style({ opacity: 0}),
				animate("250ms ease-in", style({ opacity: 1}))
			]),
			transition(":leave", [
				animate("250ms ease-out", style({ opacity: 0 }))
			]),
			state("void", style({
				opacity: 0
			})),
		]),
	]
})
export class ModalComponent implements OnDestroy, AfterViewInit {
	@Input() buttonCancel = "Cancel";
	@Input() buttonSize: "small" | "large" = "small";
	@Input() closable = true;
	// TODO: REMOVE
	@Input() disableBackgroundClick: boolean;
	@Input() disableClose: boolean;
	@Input() height: number;
	@Input() id: string;
	@Input() headingTag: "h2" | "h3" | "h4" | "h5" | "h6" = "h2";
	@Input() labelCloseButton = "Close";
	@Input() scrollable: boolean;
	@Input() size: "small" | "medium" | "large" = "medium";
	@Input() title: string;
	@Input() showButton = true;

	@Input() idFirstElementFocus: string;

	element;
	@Input() set active(val) {
		this._active = val;
		const _self = this;
		setTimeout(() => {
			if (_self._active) {
				this.element = document.activeElement;

				if(_self.modal){
					setTimeout(() => {
						document.body.appendChild(_self.modal.nativeElement);
					});
				}

				document.body.classList.add("modal-is-open");

				if (typeof _self.idFirstElementFocus !== "undefined" && _self.idFirstElementFocus !== null && val) {
					setTimeout(() => {
						document.getElementById(_self.idFirstElementFocus).focus();
					});
				} else {
					setTimeout(() => {
						document.getElementById(_self.id).focus();
					});
				}
				window.addEventListener('keydown', this.keyListener);
			} else {
				window.removeEventListener('keydown', this.keyListener);
				document.body.classList.remove("modal-is-open");
				if(this.element){
					this.element.focus();
				}
			}
		});
	}

	get active() {
		return this._active;
	}

	@Output() activeChange = new EventEmitter();
	footerFlag = true;
	@ViewChild("modal", { static : false }) modal: ElementRef;
	@ViewChild("card", { static : false }) card;

	@ViewChild("modalFootDiv", { static: false }) footer: ElementRef;

	insideCard = false;
	protected _active: boolean;

	keyListener = this.tabTrapFocusLock.bind(this);

	constructor(private idService: IdService, private cdr: ChangeDetectorRef, private tabTrap: TabTrap) {
		this.id = idService.generate();
	}

	@HostListener("document:keydown.escape", ["$event"]) onKeydownHandler(event: KeyboardEvent) {
		if (this.active && !this.disableClose) {
			this.ModalToggle("");
		}
	}

	@HostListener("document:click", ["$event"])
	clickout(event) {
		this.insideCard = !event.target.classList.contains("rbc-modal");
		if (!this.disableClose && !this.disableBackgroundClick && !this.insideCard && this.active) {
			this.active = false;
			this.activeChange.emit(this.active);
			this.cdr.markForCheck();
		}
	}

	ngAfterViewInit() {
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	classGen() {
		return {
			"rbc-modal-scrollable": this.scrollable,
			[`rbc-modal-${this.size}`]: this.size
		};
	}

	ModalToggle(e) {
		this.active = !(this.active);
		this.activeChange.emit(this.active);
	}

	tabTrapFocusLock(e) {
		if(this.modal){
			this.tabTrap.$_TabTrap_lockFocus(e, this.modal.nativeElement)
		}
	}

	// Manual open/close methods
	open() {
		this.active = true;
	}

	close() {
		this.active = false;
	}
}
